import { render, staticRenderFns } from "./home-page-standard.vue?vue&type=template&id=1aab0121&"
import script from "./home-page-standard.vue?vue&type=script&lang=ts&"
export * from "./home-page-standard.vue?vue&type=script&lang=ts&"
import style0 from "./home-page-standard.vue?vue&type=style&index=0&module=true&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports